import { Schema } from "@comparaonline/marketplace-schema";
import { ILandingData } from "../types";
import {
  getEventDescription,
  getMetaDescription,
  getMetaTitle,
  getSubtitle,
  getTitle
} from "./getDefaultConfig";

export const getConfig = (
  data: Pick<Schema.Landing, "title" | "description" | "metaTitle" | "metaDescription" | "noIndex">,
  config: any,
  landingName: string
): ILandingData => ({
  description: data.description || getSubtitle(config, landingName),
  heroDescription: getEventDescription(config),
  metaDescription: data.metaDescription || getMetaDescription(config, landingName),
  metaTitle: data.metaTitle || getMetaTitle(config, landingName),
  title: data.title || getTitle(config, landingName),
  noIndex: Boolean(data.noIndex)
});
